/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from "axios";
import { HTTP_METHOD } from "next/dist/server/web/http";

type HTTP_EXEND = HTTP_METHOD | "get" | "post" | "put" | "delete" | "patch";

export const getImgUrl = process.env.REACT_APP_GETIMAGEURL + "uploads/";
export const baseUrl = process.env.NEXT_PUBLIC_BASEURL + "api" || "";
export const baseUrlImg =
  process.env.NEXT_PUBLIC_GETIMAGEURL + "api/uploads.php" || "";

export const api = axios.create({
  baseURL: baseUrl,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

type OptionsType = {
  params?: any;
  postfix?: any;
  data?: any;
  next?: RequestInit;
};

export const nextFetch = (endURL: string) => {
  return (options?: Omit<OptionsType, "data">) => {
    const params = options?.params ? "/" + options.params : "";
    let url = `/${endURL}${params}`;
    if (options?.postfix) {
      url += options.postfix;
    }
    return fetch(baseUrl + url, options?.next);
  };
};

export const baseFunc = (endURL: string) => {
  return (method: HTTP_EXEND, options: Omit<OptionsType, "next">) => {
    const params = options?.params ? "/" + options.params : "";
    let url = `/${endURL}${params}`;
    if (options?.postfix) {
      url += options.postfix;
    }

    if (method.toLowerCase() === "get") {
      return api.get(url);
    } else if (method.toLowerCase() === "post") {
      return api.post(url, options?.data, {
        headers: {
          Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6InNoaWxwaS5iaW5kYWxAZWthbnQuaW4iLCJpYXQiOjE3MzU1NDMwODQsImV4cCI6MTczNTYyOTQ4NH0.SrzVBTTXCx2rfaztFlV3ucNMIe452S6mgXogmim01y0`,
          "Content-Type":
            options?.data instanceof FormData
              ? "multipart/form-data"
              : "application/json",
          Accept: "application/json",
        },
      });
    } else if (method.toLowerCase() === "put") {
      return api.put(url, options?.data);
    } else if (method.toLowerCase() === "delete") {
      return api.delete(url, {
        data: JSON.stringify({ deleted: 1 }),
      });
    }
  };
};
